import { Injectable } from '@angular/core';
import { ApiDataServices } from '../apiservices/api.services';

@Injectable()
export class ApirequestService {

  constructor(private api:ApiDataServices) { }

  fetchApiData(url, data, type = 'post') {
    return (type === 'post') ? this.api.postApiData(url, data) :
                              this.api.getApiData(url, data);
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/services/apirequest/apirequest.service.ts